import styled, {keyframes} from 'styled-components';

const placeHolderShimmer = keyframes`
  0% {
    background-position: -46.8rem 0;
  }
  
  100% {
    background-position: 46.8rem 0; 
  }
`;

export const contentLoader = styled.div`
  background: ${props => props.theme.colors.goBrandBlue.medium};
  background-image: linear-gradient(to right, #d1e5ff 0%, #e2efff 20%, #d1e5ff 40%, #d1e5ff 100%);
  background-size: 50rem 3.8rem;
  animation-name: ${placeHolderShimmer};
  animation-fill-mode: forwards;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  border-radius: ${props => props.theme.misc.borderRadius.small};
`;

export const SrpFiltersWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  max-width: 28.5rem;
  width:100%;
  background-color:${props.theme.colors.goWhite.base};
  border-radius:${props.theme.misc.borderRadius.large};
  margin-top:${props.theme.spacing.xlarge};
  margin: 0 auto;



`,
);

export const RowCentered = styled.div(
  props => `

  display:flex;
  align-items:center;


`,
);

export const FilterTextWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding:${props.theme.spacing.large};
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.medium};


`,
);

export const FilterContentWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding:${props.theme.spacing.large};


`,
);

export const FirstLoadderInnerDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content:space-between;
  width:100%;
  margin-bottom:${props.theme.spacing.base};

`,
);

export const FirstLoaderWrapSpan = styled(contentLoader)(
  props => `
  width:9rem;
  height:2.2rem;

`,
);

export const SecondLoaderWrapSpan = styled(contentLoader)(
  props => `
  width:5.1rem;
  height:1.8rem;
`,
);

export const HotelShowDiv = styled(contentLoader)(
  props => `
  width:14.2rem;
  height:1.6rem;
  margin-top :${props.theme.spacing.small};

`,
);

export const PopularFilterSpan = styled(contentLoader)(
  props => `
  width:12rem;
  height:1.8rem;
`,
);

export const HotelFilterDiv = styled(contentLoader)(
  props => `
  width:100%;
  height:2.5rem;
  margin-bottom:${props.theme.spacing.base};
`,
);
